/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalExamAndTreatment from './dental-exam-and-treatment';
import DentalExamAndTreatmentDetail from './dental-exam-and-treatment-detail';
import DentalExamAndTreatmentUpdate from './dental-exam-and-treatment-update';
import DentalExamAndTreatmentDeleteDialog from './dental-exam-and-treatment-delete-dialog';

const DentalExamAndTreatmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalExamAndTreatment />} />
    <Route path="new" element={<DentalExamAndTreatmentUpdate />} />
    <Route path=":id">
      <Route index element={<DentalExamAndTreatmentDetail />} />
      <Route path="edit" element={<DentalExamAndTreatmentUpdate />} />
      <Route path="delete" element={<DentalExamAndTreatmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalExamAndTreatmentRoutes;
